export default __webpack_public_path__ + "static/media/Down.61b9fdfb.svg";